/*
 * Created by Joseph Saliba on 12/16/16.
 */
export enum SortDirection {
  ASC,
  DESC
}
(window as any).SortDirection = SortDirection;
